$(function(){
  const box2ListText = document.querySelectorAll('.box2-list-text')
  const itemText1 = document.querySelector('.item1_text')
  const itemText2 = document.querySelector('.item2_text')
  const box4Video = document.getElementById("box4-video");

  let marker2 = document.querySelector("#marker4");

  let tabItem2 = document.querySelectorAll(".box6-tab a");
  let tabItemContent2 = document.querySelectorAll(".box6-tab-c-item");

  let tabItem = document.querySelectorAll(".box9-tab div");
  let tabItemContent = document.querySelectorAll(".box9-tab-c-item");

  tabItem.forEach((item,index)=>{
    item.addEventListener('click', ()=>{
      tabItem.forEach((item) => item.classList.remove('active'));
      tabItemContent.forEach((item) => item.classList.remove('active'));
      tabItemContent[index].classList.add('active');
      item.classList.add('active');
    })
  })

  


  ScrollTrigger.matchMedia({
    "(min-width: 750px)": function(){

      function indicator2(e){
        marker2.style.top = e.offsetTop + 'px';
        marker2.style.height = e.offsetHeight + 'px';
      }
    
      tabItem2.forEach((link,index) => {
      
        link.addEventListener('click', (e)=>{
          indicator2(e.target)
      
          tabItemContent2.forEach(item => {
            item.classList.remove("box6-active");
          })
          tabItem2.forEach(item => {
            item.classList.remove("box6-tab-active");
          })
      
          tabItem2[index].classList.add("box6-tab-active");
          tabItemContent2[index].classList.add("box6-active");
        })
      
        link.addEventListener('mouseover', (e)=>{
          indicator2(e.target)
      
          tabItemContent2.forEach(item => {
            item.classList.remove("box6-active");
          })
          tabItem2.forEach(item => {
            item.classList.remove("box6-tab-active");
          })
      
          tabItem2[index].classList.add("box6-tab-active");
          tabItemContent2[index].classList.add("box6-active");
        })
      
      })

      ScrollTrigger.create({
        trigger: '.box2-content',
        start: 'top 20%',
        end:'bottom 20%',
        scrub: true,
        onEnter(){
            box2ListText.forEach((item) => item.classList.add('animated-element'));
        }
      })
    },
    "(max-width: 750px)": function(){

      function indicator2(e){
        marker2.style.left = e.offsetLeft + 'px';
        marker2.style.width = e.offsetWidth + 'px';
      }
    
      tabItem2.forEach((link,index) => {
      
        link.addEventListener('click', (e)=>{
          indicator2(e.target)
      
          tabItemContent2.forEach(item => {
            item.classList.remove("box6-active");
          })
          tabItem2.forEach(item => {
            item.classList.remove("box6-tab-active");
          })
      
          tabItem2[index].classList.add("box6-tab-active");
          tabItemContent2[index].classList.add("box6-active");
        })
      
        link.addEventListener('mouseover', (e)=>{
          indicator2(e.target)
      
          tabItemContent2.forEach(item => {
            item.classList.remove("box6-active");
          })
          tabItem2.forEach(item => {
            item.classList.remove("box6-tab-active");
          })
      
          tabItem2[index].classList.add("box6-tab-active");
          tabItemContent2[index].classList.add("box6-active");
        })
      
      })

      ScrollTrigger.create({
        trigger: '.box2-content',
        start: 'top 50%',
        end:'bottom 50%',
        scrub: true,
        onEnter(){
            box2ListText.forEach((item) => item.classList.add('animated-element'));
        }
      })
    }
  })
  

  ScrollTrigger.create({
    trigger: '.box4-bottom-item1',
    start: 'center 80%',
    end:'bottom 80%',
    scrub: true,
    onEnter(){
      itemText1.classList.add('animated-element')
    }
  })

  ScrollTrigger.create({
    trigger: '.box4-bottom-item2',
    start: 'center 80%',
    end:'bottom 80%',
    scrub: true,
    onEnter(){
      itemText2.classList.add('animated-element')
    }
  })

  let num = 0
  ScrollTrigger.create({
    trigger: '#box4-video',
    start: 'top 60%',
    end:'bottom bottom',
    scrub: true,
    onEnter(){
      if(num === 0){
        box4Video.play()
        num = 1
      }
    }
  })

})
